export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7072e8d727541dfbaaf5646047a4f8bac40d5aab9e&name=pushAdClickData!'